<template>
  <v-container>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- <div v-if="userId == 11020106 || userId == 11010160">
      {{ interfaceTime }}
      <div v-if="interfaceTime.length > 1">
        {{ ((interfaceTime[1] - interfaceTime[0]) / 1000).toFixed(2) }}
      </div>
    </div> -->
    <!-- <div
      v-if="userId == 11020106 || userId == 11010160 || userId == 87094024"
      class="mb-3"
    >
      <div v-for="(item, index) in APIStatus" :key="index">
        <span>{{ item[0] }}</span>
        <span class="mx-2 blue--text">{{ item[1] }}</span>
        <span :class="item[4] > 1 ? 'red--text' : ''">{{ item[4] }}</span>
      </div>
    </div> -->

    <v-card>
      <div class="mx-auto home-width pt-4 px-4 pb-10">
        <div
          class="amber darken-1 pa-1"
          style="border-radius: 10px; margin: 0 -4px"
        >
          <div class="d-flex justify-space-between align-center pa-1">
            <span
              class="text-h4 white--text d-flex align-center bulletin-board"
            >
              <v-icon class="red--text text--darken-3"
                >fa-solid fa-layer-group</v-icon
              >
              網路佈告欄
            </span>
            <span
              class="text-h6 red--text text--darken-3 cursor"
              @click="$router.push('/notes-board')"
              >看更多＞</span
            >
          </div>
          <div>
            <div
              class="text-h6 white pa-2 announce-list"
              style="position: relative"
              @touchstart="touchstart($event)"
              @touchmove="touchmove($event)"
            >
              <v-overlay absolute :value="announceLoading" opacity="0">
                <v-progress-circular
                  indeterminate
                  size="30"
                  color="amber darken-4"
                ></v-progress-circular>
              </v-overlay>
              <div
                v-show="!announceLoading"
                v-for="(item, i) in announcement"
                :key="i"
                class="li cursor"
                @click="openAnnounceDialog(item)"
              >
                <div class="d-flex justify-space-between">
                  <span class="mr-2 indigo--text text--accent-4">{{
                    item.bulletinBoard.boarD_TYPE
                  }}</span>
                  <span class="amber--text text--darken-3 mr-2">{{
                    $dayjs(item.bulletinBoard.lasT_UPDATE_DATE).format(
                      "YYYY-MM-DD"
                    )
                  }}</span>
                </div>
                <div class="black--text">
                  {{ item.bulletinBoard.issuE_SUBJECT }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!offDuty"
          class="box mt-6 amber darken-4 white--text d-flex align-center justify-space-between px-5 py-2 font-weight-bold"
          @click="$router.push('/sign')"
        >
          <div class="text-h3 sign-box">簽核流程平台</div>
          <div
            class="white amber--text text--darken-4 text-h5 text-center py-1 sign-count"
          >
            待簽核: {{ signCount }}
          </div>
          <v-icon v-if="!$vuetify.breakpoint.xs" color="white" large
            >fa-solid fa-circle-play</v-icon
          >
        </div>
        <v-row class="my-6">
          <v-col
            cols="6"
            sm="4"
            v-for="(item, i) in subjectLists"
            :key="i"
            class="text-center pb-0 flex-grow-1 flex-shrink-0"
            style="max-width: 100%"
            @click="toDetailPage(item)"
          >
            <v-card
              class="amber lighten-4 amber--text text--darken-4 d-flex flex-column align-center justify-center cateory pa-4"
              elevation="0"
              style="height: 100%"
            >
              <v-icon
                x-large
                color="amber darken-4"
                :class="item.icon.includes('$eip') ? 'custom-icon' : ''"
                >{{ item.icon }}</v-icon
              >
              <div class="text-h5 mt-2" style="white-space: pre-line">
                {{ item.text }}
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div class="text-h4">常用功能</div>
        <v-card class="pa-2 frequent-card mt-6" v-if="frequentList.length">
          <div
            v-for="(item, i) in frequentList"
            :key="i"
            class="pa-2 d-flex align-center justify-space-between grey--text text--darken-1 text-h5"
            :style="[
              i != frequentList.length - 1
                ? { 'border-bottom': '1px solid #ccc' }
                : {},
            ]"
            @click="toFrequentPage(item)"
          >
            {{ item.name }}
            <v-icon color="amber darken-4">fa-solid fa-chevron-right</v-icon>
          </div>
        </v-card>
      </div>
    </v-card>

    <v-navigation-drawer
      v-model="announceDrawer"
      fixed
      temporary
      right
      touchless
    >
      <div class="pa-4 d-flex">
        <span class="text-h5">條件篩選</span>
        <v-spacer></v-spacer>
        <v-icon @click="announceDrawer = false">fa-solid fa-xmark</v-icon>
      </div>
      <v-divider></v-divider>
      <div class="pa-4 text-h6">
        搜尋：
        <br />
        <v-text-field
          hide-details=""
          dense
          color="black"
          placeholder="請輸入搜尋文字"
          v-model="search"
        ></v-text-field>
        <br />
        日期：
        <br />
        <v-chip-group
          v-model="announceSort"
          column
          mandatory
          active-class="amber--text text--darken-4"
        >
          <v-chip label class="text-h6" value="1"> 遞減 </v-chip>
          <v-chip label class="text-h6" value="0"> 遞增 </v-chip>
        </v-chip-group>
        <br />
        分類：
        <v-select
          :items="announceTypeList"
          dense
          v-model="selectedAnnounceTypeList"
          hide-details=""
          color="black"
        ></v-select>
        <br />
        筆數：
        <v-select
          :items="pageSizeRange"
          dense
          v-model="pageSize"
          hide-details=""
          color="black"
        ></v-select>
        <br />
        <v-btn
          block
          color="amber darken-4"
          dark
          rounded
          @click="
            pageIndex = 1;
            getAnnouncement();
            announceDrawer = false;
          "
          class="text-h6"
          >套用</v-btn
        >
      </div>
    </v-navigation-drawer>

    <v-dialog v-model="bioSetDialog" scrollable max-width="600" persistent>
      <v-card class="px-4">
        <v-card-text class="pa-7" style="position: relative">
          <div
            class="text-h4 cursor"
            style="position: absolute; right: 0px; top: 15px"
            variant="flat"
            @click="bioSetDialog = false"
          >
            <i class="fa-solid fa-circle-xmark" style="color: #bdbdbd"></i>
          </div>
          <div>
            <div
              border="left"
              class="py-0 mb-3 d-flex justify-content-start align-center text-h5 pr-3"
              style="
                color: #c62828;
                font-weight: 700;
                background-color: inherit;
              "
              dense
              tile
              colored-border
              color="#c62828"
              elevation="0"
            >
              指紋/臉部登入{{ isFirstLogin ? "設定提示" : "密碼錯誤" }}
            </div>
            <p class="text-h6 mb-6" style="color: #000">
              是否前往設定{{
                isFirstLogin ? "建立" : "更新"
              }}指紋/臉部登入密碼？
            </p>
            <div class="d-flex justify-center">
              <v-btn
                class="mx-2"
                color="grey"
                style="
                  border-radius: 11px;
                  width: 124px;
                  font-size: 20px;
                  height: 30px;
                "
                dark
                label
                @click="bioSetDialog = false"
                >暫不前往
              </v-btn>
              <v-btn
                class="mx-2"
                color="amber darken-4"
                style="
                  border-radius: 11px;
                  width: 124px;
                  font-size: 20px;
                  height: 30px;
                "
                dark
                label
                @click="
                  bioSetDialog = false;
                  $router.push('/setting?triggerBioDialog=true');
                "
                >確定
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="announceDialog" scrollable max-width="600" persistent>
      <v-card>
        <v-card-text class="px-7 pt-7 pb-0" style="position: relative">
          <div
            class="text-h4 cursor"
            style="position: absolute; right: 6px; top: 6px"
            variant="flat"
            @click="announceDialog = false"
          >
            <i class="fa-solid fa-circle-xmark" style="color: #ff6f00"></i>
          </div>
          <div>
            <div
              class="mb-6 black--text mr-3 mt-2 text-body-1"
              v-if="selectAnnounce"
            >
              <div class="grid-container additional-border">
                <div class="grid-item amber lighten-4" style="grid-column: 1/2">
                  執行廠區
                </div>
                <div class="grid-item" style="grid-column: 2/3">
                  {{ selectAnnounce.bulletinBoard?.area }}
                </div>
                <div class="grid-item amber lighten-4" style="grid-column: 3/4">
                  佈告類型
                </div>
                <div class="grid-item" style="grid-column: 4/5">
                  {{ selectAnnounce.bulletinBoard?.boarD_TYPE }}
                </div>
                <div class="grid-item amber lighten-4" style="grid-column: 1/2">
                  發佈單位
                </div>
                <div class="grid-item" style="grid-column: 2/3">
                  {{ selectAnnounce.bulletinBoard?.issuE_UNIT }}
                </div>
                <div class="grid-item amber lighten-4" style="grid-column: 3/4">
                  聯絡電話
                </div>
                <div class="grid-item" style="grid-column: 4/5">
                  {{ selectAnnounce.bulletinBoard?.contacT_TEL }}
                </div>
                <div class="grid-item amber lighten-4" style="grid-column: 1/2">
                  開始發佈日期
                </div>
                <div class="grid-item" style="grid-column: 2/3">
                  {{
                    $dayjs(
                      selectAnnounce.bulletinBoard?.starT_ISSUE_DATE
                    ).format("YYYY-MM-DD")
                  }}
                </div>
                <div class="grid-item amber lighten-4" style="grid-column: 3/4">
                  結束發佈日期
                </div>
                <div class="grid-item" style="grid-column: 4/5">
                  {{
                    $dayjs(selectAnnounce.bulletinBoard?.enD_ISSUE_DATE).format(
                      "YYYY-MM-DD"
                    )
                  }}
                </div>
                <div class="grid-item amber lighten-4" style="grid-column: 1/2">
                  佈告主旨
                </div>
                <div class="grid-item" style="grid-column: 2/5">
                  {{ selectAnnounce.bulletinBoard?.issuE_SUBJECT }}
                </div>
                <div class="grid-item" style="grid-column: 1/5">
                  <div>佈告內容:</div>
                  <div
                    v-html="selectAnnounce.bulletinBoard?.issuE_CONTENT"
                    style="overflow-x: auto"
                  ></div>
                </div>
              </div>
              <div v-if="selectAnnounce.appendixs?.length">
                <div
                  class="grid-container2 additional-border"
                  v-for="(appendixs, index) in selectAnnounce.appendixs"
                  :key="index"
                >
                  <div class="grid-item" style="grid-column: 1/2">附件</div>
                  <div
                    class="grid-item cursor"
                    style="grid-column: 2/3"
                    @click="getAppendixFile(appendixs.url)"
                  >
                    {{ appendixs.filename }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="pb-6 pt-2">
          <v-btn
            class="d-flex flex-column justify-end px-4 py-0"
            color="#FF6F00"
            style="
              border-radius: 11px;
              width: 145px;
              font-size: 20px;
              height: 30px;
              margin: 0 auto;
            "
            dark
            label
            @click="announceDialog = false"
            >關閉
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="privacyDialog" scrollable max-width="600" persistent>
      <v-card class="px-4">
        <v-card-text class="pa-7" style="position: relative">
          <div>
            <div
              border="left"
              class="py-0 mb-3 d-flex justify-content-start align-center text-h5 pr-3"
              style="
                color: #c62828;
                font-weight: 700;
                background-color: inherit;
              "
              dense
              tile
              colored-border
              color="#c62828"
              elevation="0"
            >
              敬告
            </div>
            <div class="text-h6 mb-6" style="color: #000">
              <p>
                1.
                統一企業行動入口網內的資訊，嚴禁翻拍與洩漏，故意洩漏公司營業上之秘密，致公司受損害者，將負相關法律責任。
              </p>
              <p>
                2. 使用條款規範:
                <br />
                <span class="mx-2">─</span
                >請同仁珍惜公司資源，非依法令或授權，勿任意將公司內部資料對外揭露、轉寄、下載，亦不得任意
                擷取、散布、改作其全部或部份內容。
                <br />
                <span class="mx-2">─</span
                >尊重智慧財產權，本網站著作權為統一企業所有，轉載必究。
              </p>
              <p>
                3. 個人資料保護政策: 請參閱統一企業官網，
                <span
                  class="blue--text text--lighten-1 text-decoration-underline cursor"
                  @click="
                    getAppendixFile(
                      'https://www.uni-president.com.tw/other_service/personal.asp'
                    )
                  "
                >
                  個人資料保護政策。
                </span>
              </p>
            </div>
            <v-btn
              class="d-flex flex-column justify-end px-4 py-0"
              color="#FF6F00"
              style="
                border-radius: 11px;
                width: 145px;
                font-size: 20px;
                height: 30px;
                margin: 0 auto;
              "
              dark
              label
              @click="ConfirmPrivacyContent()"
              >確定
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapWritableState } from "pinia";
import { useAppStore } from "@/stores/appStore";
import { apiAxios } from "@/api";
import { db } from "@/firebase";
import { collection, addDoc } from "firebase/firestore";
import jwt_decode from "jwt-decode";

export default {
  name: "HomeView",
  data() {
    return {
      subjectLists: [
        {
          text: "考勤/請假",
          route: true,
          src: "/leave",
          icon: "fa-solid fa-calendar",
        },
        {
          text: "人資行動服務平台",
          route: false,
          src: "https://nrm2.pec.com.tw/pls/tp22/f?p=200:101:1750730720958:::::",
          icon: "fa-regular fa-address-card",
        },
        {
          text: `薪資/獎金/\r\n所得/保險\r\n個人信箱&緊急聯絡人維護`,
          route: true,
          src: "/salary-login",
          icon: "$eip_salary_chart",
        },
        {
          text: "ERP資料查詢",
          route: true,
          src: "/erp",
          icon: "fa-solid fa-laptop-file",
        },
        {
          text: "其他系統服務區",
          route: true,
          src: "/other",
          icon: "fa-solid fa-indent",
        },
        {
          text: "訂便當",
          route: true,
          src: "/bento",
          icon: "fa-solid fa-utensils",
        },
      ],
      signList: [],
      isLoading: false,
      signCount: 0,
      frequentList: [],
      bioSetDialog: false,
      isFirstLogin: false,
      announcement: [],
      announceDialog: false,
      selectAnnounce: {},
      pageIndex: "1",
      pageSize: "25",
      pageSizeRange: ["25", "50", "100"],
      pagingInfo: {},
      search: "",
      announceTypeList: [],
      selectedAnnounceTypeList: "",
      announceSort: "1",
      pathRecord: "",
      announceLoading: false,
      announceDrawer: false,
      privacyDialog: false,
      offDuty: false,
    };
  },
  computed: {
    ...mapWritableState(useAppStore, [
      "showChangeBioSettingDialog",
      "isSalaryLogin",
      "salaryAlertMsg",
    ]),
    ...mapState(useAppStore, [
      "userId",
      "isLogin",
      "imgUrl",
      "leaveNotAllow",
      "salaryKey",
      "navDrawerListsNew",
      "APIStatus",
      "interfaceTime",
      "accessToken",
    ]),
  },
  watch: {
    leaveNotAllow: {
      immediate: true,
      handler(val) {
        if (val) {
          this.subjectLists[0].text = "考勤查詢";
        }
      },
    },
  },
  async mounted() {
    try {
      this.isLoading = true;

      await this.getLeaveFlag().catch((error) => {
        this.$dialog.show(`取得請假權限時出現錯誤，${error}`);
      });
      if (!this.navDrawerListsNew.length) {
        this.getNewNavDrawerLists();
      }
      return Promise.all([
        this.ConfirmPrivacyContentCheck(),
        this.getSignList(),
        this.getFrequentList(),
        this.getAnnouncement(),
        this.getAnnounceTypeList(),
        this.getOffDuty(),
      ]).finally(() => (this.isLoading = false));
    } catch (error) {
      try {
        await addDoc(collection(db, "loadingErrorLogs"), {
          userId: this.userId,
          error: error,
          creationDate: new Date(),
          page: "HomeView",
        });
      } catch (error) {
        null;
      }
      window.location.reload();
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    ...mapActions(useAppStore, [
      "logout",
      "getNotificationLength",
      "getLeaveFlag",
      "handleDialogOverlay",
      "getNewNavDrawerLists",
    ]),
    touchstart(e) {
      e.stopPropagation();
    },
    touchmove(e) {
      e.stopPropagation();
    },
    triggerBioDialog() {
      if (JSON.parse(localStorage.getItem("eip_is_supported_bio"))) {
        // 跳出視窗提示使用者變更錯誤的生物辨識密碼
        if (this.showChangeBioSettingDialog && window.EipJSInterface) {
          this.bioSetDialog = true;
          this.showChangeBioSettingDialog = false;
          this.isFirstLogin = false;
        }
        // 跳出視窗提示使用者第一次設定生物辨識密碼
        let bioStatus = localStorage.getItem("eip_bio_enable_status");
        let [ad, hr] = bioStatus.split(",");
        if (JSON.parse(ad) || JSON.parse(hr)) {
          localStorage.setItem("eip_is_first_login", 1);
        }
        if (
          !JSON.parse(localStorage.getItem("eip_is_first_login")) &&
          window.EipJSInterface
        ) {
          this.bioSetDialog = true;
          localStorage.setItem("eip_is_first_login", 1);
          this.isFirstLogin = true;
        }
      }
    },
    getSignList() {
      return apiAxios({
        method: "post",
        url: process.env.VUE_APP_SIGN_API + "/Wf/WfList",
      })
        .then((res) => {
          this.signList = res.result;
          this.signCount = this.signList.length;
        })
        .catch((error) => {
          this.$dialog.show(`簽核系統錯誤 ${error}`);
        });
    },
    toDetailPage(item) {
      if (item.route) {
        if (item.src == "/salary-login") {
          this.isLoading = true;
          apiAxios({
            method: "post",
            url: process.env.VUE_APP_LEAVE_API + "/Send",
            data: {
              apiName: "afl",
              url: "api/EIP/Get_Eip_CheckAuth",
              data: {
                emp_no: this.userId,
                key: this.salaryKey,
              },
            },
          }).then((res) => {
            const result = JSON.parse(res.Message);
            this.isLoading = false;
            /**
             * pw_flag:
             * null，驗證成功 > 前往 /salary-view
             * 1，無員工自助帳號 > 擋下
             * 2，尚未登入 > 前往 /salary-login
             * 3，需輸入新的自助帳密；或是距上次輸入已超過45天，需重新登入 > 前往 /salary-login
             * 4，非授權使用系統 > 擋下
             */
            if (!result.pw_flag) {
              // this.isSalaryLogin = true;
              this.$router.push("/salary-view");
            } else if (result.pw_flag == 2 || result.pw_flag == 3) {
              this.$router.push(item.src);
            } else {
              // 顯示錯誤 dialog
              this.$dialog.show(
                result.msg ||
                  `發生不可預期錯誤，請聯絡資訊人員，pw_flag: ${result.pw_flag}`
              );
            }
            this.salaryAlertMsg = result.msg;
          });
        } else {
          this.$router.push(item.src).catch(() => null);
        }
      } else {
        if (item.src) {
          // if (window.EipJSInterface) {
          //   window.location.href = `${item.src}&external_browser=1`;
          // } else {
          //   window.open(item.src);
          // }
          if (window.EipJSInterface && window.EipJSInterface.openInAppBrowser) {
            window.EipJSInterface.openInAppBrowser(item.src);
          } else {
            window.open(item.src);
          }
        }
      }
    },
    getFrequentList() {
      return apiAxios({
        method: "post",
        url: process.env.VUE_APP_ROOT_API + "/Url/GetFrequentlyUsedUrl",
        data: {
          leave_auth: this.leaveNotAllow ? "N" : "Y",
        },
      })
        .then((res) => {
          this.frequentList = res.result;

          let settingId = this.frequentList.findIndex(
            (e) => e.url == "/setting"
          );
          if (!window.EipJSInterface && settingId !== -1) {
            this.frequentList.splice(settingId, 1);
          }
          let diviceId = this.frequentList.findIndex(
            (e) => e.url == "/device-state"
          );
          if (!window.EipJSInterface && diviceId !== -1) {
            this.frequentList.splice(diviceId, 1);
          }
        })
        .catch((error) => {
          this.$dialog.show(`取得常用功能列表時發生錯誤， ${error}`);
        });
    },
    getAnnouncement(pageDirection = "") {
      this.announceLoading = true;
      let tempUrl;
      let type = this.selectedAnnounceTypeList
        ? `&type=${this.selectedAnnounceTypeList}`
        : "";
      let search = this.search ? `&search=${this.search}` : "";
      tempUrl = `/NotesBoard/List?pageIndex=${this.pageIndex}&pageSize=${this.pageSize}${type}${search}&sort=${this.announceSort}`;
      if (pageDirection) {
        tempUrl = this.pagingInfo[`${pageDirection}PageLink`].split("api")[1];
      }

      let samePath = false;
      if (pageDirection && this.pathRecord == tempUrl) samePath = true;

      if (samePath) {
        if (pageDirection == "next") {
          this.$snackbar.add("已在佈告欄最末頁", { color: "info" });
        }
        if (pageDirection == "prev") {
          this.$snackbar.add("已在佈告欄首頁", { color: "info" });
        }
        this.announceLoading = false;
      } else {
        return apiAxios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + tempUrl,
        })
          .then((res) => {
            this.announcement = res.result;
            this.pagingInfo = res.pagingInfo;
            this.pageIndex = res.pagingInfo.currentPage;
            this.pathRecord = tempUrl;
          })
          .catch((error) => {
            this.$dialog.show(`無法正確取得佈告欄資訊， ${error}`);
          })
          .finally(() => {
            this.announceLoading = false;
          });
      }
    },
    openAnnounceDialog(item) {
      return apiAxios({
        method: "get",
        url:
          process.env.VUE_APP_ROOT_API +
          `/NotesBoard/Get/${item.bulletinBoard.id}`,
      })
        .then((res) => {
          this.selectAnnounce = res;
          this.announceDialog = true;
          this.handleDialogOverlay();
        })
        .catch((error) => {
          this.$dialog.show(`無法正確取得佈告欄明細資訊， ${error}`);
        });
    },
    getAppendixFile(url) {
      if (url.includes(".pdf")) {
        if (window.EipJSInterface && window.EipJSInterface.openPDFReaderInApp) {
          window.EipJSInterface.openPDFReaderInApp(url);
        } else {
          window.open(url);
        }
      } else {
        if (window.EipJSInterface && window.EipJSInterface.openInAppBrowser) {
          window.EipJSInterface.openInAppBrowser(url);
        } else {
          window.open(url);
        }
      }
    },
    getAnnounceTypeList() {
      return apiAxios({
        method: "get",
        url: process.env.VUE_APP_ROOT_API + `/NotesBoard/Classification`,
      })
        .then((res) => {
          this.announceTypeList = res.map((e) => ({
            text: e,
            value: e == "全部" ? "" : e,
          }));
        })
        .catch((error) => {
          this.$dialog.show(`無法取得佈告欄分類，${error}`);
        });
    },
    outAppTest() {
      console.log("outAppTest");
      if (window.EipJSInterface && window.EipJSInterface.openOutAppBrowser) {
        window.EipJSInterface.openOutAppBrowser(
          "https://nrm2.pec.com.tw/pls/tp22/f?p=200:101:1750730720958:::::"
        );
      }
    },
    inAppNullTest() {
      console.log("inAppNullTest");
      if (window.EipJSInterface && window.EipJSInterface.openInAppBrowser) {
        window.EipJSInterface.openInAppBrowser(null);
      }
    },
    toFrequentPage(item) {
      if (item.url.includes("http")) {
        if (item.url.includes(".pdf")) {
          if (
            window.EipJSInterface &&
            window.EipJSInterface.openPDFReaderInApp
          ) {
            window.EipJSInterface.openPDFReaderInApp(item.url);
          }
        } else {
          if (window.EipJSInterface && window.EipJSInterface.openInAppBrowser) {
            window.EipJSInterface.openInAppBrowser(item.url);
          } else {
            window.open(item.url);
          }
        }
      } else {
        this.$router.push(item.url);
      }
    },
    ConfirmPrivacyContentCheck() {
      return apiAxios({
        method: "post",
        url:
          process.env.VUE_APP_ROOT_API + `/Privacy/ConfirmPrivacyContentCheck`,
      })
        .then((res) => {
          this.privacyDialog = res.result == "Y" ? false : true;
          if (!this.privacyDialog) {
            this.triggerBioDialog();
          }
        })
        .catch((error) => {
          // this.$dialog.show(`無法取得隱私權狀態，${error}`);
          // 使用 snackbar 避免影響生物辨識視窗
          this.$snackbar.add(`無法取得隱私權狀態，${error}`);
          this.triggerBioDialog();
        });
    },
    ConfirmPrivacyContent() {
      return apiAxios({
        method: "post",
        url: process.env.VUE_APP_ROOT_API + `/Privacy/ConfirmPrivacyContent`,
      })
        .then(() => {
          this.privacyDialog = false;
        })
        .catch((error) => {
          // this.$dialog.show(`更正隱私權狀態時出現錯誤，${error}`);
          // 使用 snackbar 避免影響生物辨識視窗
          this.$snackbar.add(`更正隱私權狀態時出現錯誤，${error}`);
          this.privacyDialog = false;
        })
        .finally(() => {
          this.triggerBioDialog();
        });
    },
    getOffDuty() {
      let jwt = jwt_decode(this.accessToken);
      this.offDuty = jwt.is_off_duty == "Y" ? true : false;
    },
  },
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.box {
  border-radius: 20px;
  cursor: pointer;
}
:deep(.fa-magnifying-glass) {
  font-size: 19px;
}
.announce-list {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  height: 250px;
  overflow-y: auto;
}
.announce-list .li:nth-child(1n + 3) {
  /* text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap; */
  border-top: 2px solid #d3c9c9;
  padding-top: 8px;
  /* font-size: 1rem !important; */
}
.sign-count {
  border-radius: 30px;
  width: 35%;
}
.cateory {
  height: 167px;
  border-radius: 30px;
  cursor: pointer;
}
.frequent-card {
  border-radius: 20px !important;
}
.frequent-card div {
  cursor: pointer;
}
.grid-container {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 2fr;
  gap: 1px;
}
.grid-item {
  outline: 1px solid rgba(0, 0, 0, 0.12);
  padding: 8px;
  overflow-wrap: break-word;
  outline: 1px solid rgba(0, 0, 0, 0.12);
}
.grid-container2 {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1px;
}
.additional-border {
  outline: 1px solid rgba(0, 0, 0, 0.12);
}
.announce-setting :deep(.v-btn.v-size--default) {
  font-size: 1rem !important;
}
.custom-icon {
  font-size: 52px !important;
  height: 52px !important;
  width: 52px !important;
}
.custom-icon :deep(svg) {
  font-size: 52px !important;
  height: 52px !important;
  width: 52px !important;
}
@media (max-width: 992px) {
  .v-application .text-h3 {
    font-size: 2.3rem !important;
  }
}
@media (max-width: 442px) {
  .fa-circle-play {
    font-size: 30px !important;
  }
  .input {
    width: 50%;
  }
  #app .home-width .text-h3.sign-box {
    font-size: 26px !important;
  }
}
@media (max-width: 376px) {
  .bulletin-board {
    font-size: 24px !important;
  }
  #app .home-width .text-h3.sign-box {
    font-size: 24px !important;
  }
}
</style>
